import React from 'react';
import { Grid, TextField } from '@mui/material';
import FormSection from './FormSection';

const PartyInfoSection = ({ title, formData, handleInputChange, prefix }) => {
  return (
    <FormSection title={title} sx={{ height: '100%', p: 4 }}>
      <TextField
        label={`Nom du ${prefix === 'seller' ? 'vendeur' : 'client'}`}
        name={`${prefix}_name`}
        value={formData?.[`${prefix}_name`] || ''}
        onChange={handleInputChange}
        fullWidth
        required
        margin="normal"
      />
      
      {prefix === 'buyer' && (
        <TextField
          label="Identifiant client"
          name="buyer_id"
          value={formData?.buyer_id || ''}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
        />
      )}
      
      <TextField
        label={`Adresse ${prefix === 'seller' ? 'du vendeur' : 'de facturation'}`}
        name={`${prefix}_address`}
        value={formData?.[`${prefix}_address`] || ''}
        onChange={handleInputChange}
        fullWidth
        required
        margin="normal"
        multiline
        rows={2}
      />
      
      {prefix === 'buyer' && (
        <TextField
          label="Adresse de livraison"
          name="shipping_address"
          value={formData?.shipping_address || ''}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
          multiline
          rows={2}
        />
      )}
      
      {prefix === 'seller' && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Téléphone"
              name="seller_phone"
              value={formData?.seller_phone || ''}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Email"
              name="seller_email"
              value={formData?.seller_email || ''}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />
          </Grid>
        </Grid>
      )}
      
      {prefix === 'seller' && (
        <TextField
          label="Site web"
          name="seller_website"
          value={formData?.seller_website || ''}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
        />
      )}
      
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Numéro de TVA"
            name={`${prefix}_vat`}
            value={formData?.[`${prefix}_vat`] || ''}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Numéro SIREN"
            name={`${prefix}_siret`}
            value={formData?.[`${prefix}_siret`] || ''}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />
        </Grid>
      </Grid>
      
      {prefix === 'seller' && (
        <TextField
          label="Coordonnées bancaires"
          name="seller_payment_details"
          value={formData?.seller_payment_details || ''}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
          multiline
          rows={2}
        />
      )}
    </FormSection>
  );
};

export default PartyInfoSection;